<template>
    <div class="my-6 mb-12">
        <div class="d-flex d-block align-center">
            <div class="sansation label_medium info--text d-inline">Module Roadmap Steps</div>
        </div>

        <div v-if="!readyToLoadRoadmap" class="text-center py-12 my-12" style="width: 100%">
			<v-progress-circular
				indeterminate 
				color="error darken-3" 
				class="my-12 py-12" 
				size="100" 
				width="8">
			</v-progress-circular>
		</div>
		
		<div v-else>
            <RoadmapDisplay 
                v-if="module_roadmap_data.length"
                :stages="module_roadmap_data" 
                :canEdit="canEdit" />
            <div v-else-if="readyToLoadRoadmap && !module_roadmap_data.length" class="sansation label_medium info--text">No roadmap steps available</div>
        </div>
    </div>
</template>


<script>  
    import axios from "axios";
	import Cookie from 'js-cookie';
	import appUrls from '../helpers/environment';
    import dateFormat, { masks } from "dateformat";

    import RoadmapDisplay from './shared/roadmapDisplay.vue';

    export default {
        name: 'ModuleRoadmap',

        components: {
            RoadmapDisplay
        },

        props: {
            moduleID: String,
            toggleVisiblity: Function,
            playResourceVideo: Function,
        },

        data() {
            return {
                readyToLoadRoadmap: false,
                module_roadmap_data: [],
                canEdit: false,
            }
        },
        
        methods: {    
            parseStageDetails: function (stageDetails) {
                try {
                    if (stageDetails === null || stageDetails === undefined) {
                        return null
                    }

                    if (typeof stageDetails === 'object') {
                        return stageDetails
                    }

                    const trimmed = String(stageDetails).trim()
                    if (!trimmed || trimmed === 'null' || trimmed === 'undefined') {
                        return null
                    }

                    return JSON.parse(trimmed)
                } catch (error) {
                    console.warn('Unable to parse stage extra_details.', stageDetails)
                    return null
                }
            },

            getRoadmapSteps: async function () {
				try {
					const roadmap_rs = await axios.get(`${appUrls.api}/api/admin/module_roadmap/${this.moduleID}`, {
						headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
					})

                    if ( !roadmap_rs.data.outcome ) {
                        return []
                    }

                    const module_details = await Promise.all(roadmap_rs.data.module_roadmap_data.map( async step => {
                        if ( step.stage_desc.includes('vInfuseVideoList') ) {
                            step.stage_desc = await this.infuseDynamicContent( [], step.stage_desc, 'vInfuseVideoList' )
                        } else if ( step.stage_desc.includes('vInfuseVideoSingle') ) {
                            step.stage_desc = await this.infuseDynamicContent( [], { stage_desc: step.stage_desc, extra_details: step.extra_details }, 'vInfuseVideoSingle' )
                        } else if ( step.stage_desc.includes('vInfuseRevisedContract') && step.stage_type == 'completion' ) {
                            step.stage_desc = await this.infuseDynamicContent( [], step.stage_desc, 'vInfuseRevisedContract' )
                        } else if ( step.stage_desc.includes('vInfuseScheduleCall') ) {
                            step.stage_desc = await this.infuseDynamicContent( [], step.stage_desc, 'vInfuseScheduleCall', step.show_calendly )
                        } else if ( step.stage_desc.includes('vInfuseScheduleDebriefCall') ) {
                            step.stage_desc = await this.infuseDynamicContent( [], step.stage_desc, 'vInfuseScheduleDebriefCall', step.show_calendly )
                        }  else if ( step.stage_desc.includes('vInfuseUploadRevisions') ) {
                            step.stage_desc = await this.infuseDynamicContent( [], step.stage_desc, 'vInfuseUploadRevisions', step.show_revisions_upload )
                        } 
                        return step
                    }))

                    return module_details

				} catch ( error ) {
					console.log(error);
				}
            },

            // openVideo ( data ) {
            //     this.$emit('playResourceVideo', data )
            // },

            resourceVisibility ( data, type ) {
                this.$emit('toggleVisiblity', data, type )
            },
            
            formatDate: function ( date, mask ) {
                return dateFormat(date, mask)
            },

            adminOnly: async function () {
                try {
                    const admin_rs = await axios.get(`${appUrls.api}/api/admin/is_super/${Cookie.get('bool')}`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                    })

                    this.canEdit = admin_rs.data.root || admin_rs.data.super || admin_rs.data.adv;
                
                } catch ( error ) {
                    console.log(error);
                }
            },

            infuseDynamicContent: async function ( prj_details, content, identifier, display=false ) {
                // console.log(prj_details)
                // console.log(prj_details.resource_visibility)
                try {
                    let infused_content = ''
                    switch ( identifier ) {
                        case 'vInfuseVideoList':
                            const visible_videos = prj_details.length ? prj_details.resources.filter( vid => vid.is_visible_overview) : [];
                            let infuse_list = `<ul>`
                            
                            if ( visible_videos.length ) {
                                prj_details.resources.forEach( video => {
                                    const visibility_record = Array.isArray(prj_details.resource_visibility)
                                        ? prj_details.resource_visibility.find(file => file.file_id == video.file_id)
                                        : null
                                    if ( visibility_record && visibility_record.is_visible_overview ) {
                                        const display_name = visibility_record.is_visible ? `${video.client_label} <i class="v-icon notranslate ml-2 mdi mdi-checkbox-marked-circle theme--light secondary--text" style="font-size: 19px;"></i>` : `${video.client_label}`
                                        infuse_list += `<li><a data-function="playResourceVideo" data-fileid="${video.file_id}" data-url="${video.url}" data-title="${video.client_label}" data-type="${video.type}">${display_name}</a></li>`
                                    }
                                })
                            } else {
                                infuse_list += `<li><strong>Videos will be visible here when this is the current step.</strong></li>`
                            }
                            infuse_list += `</ul>`
                            infused_content = content.replace(/vInfuseVideoList/g, infuse_list)

                            return infused_content
                        break;

                        case 'vInfuseVideoSingle':
                            const extra_details = this.parseStageDetails(content.extra_details);
                            if (!extra_details || !extra_details.stage_video) {
                                return content.stage_desc.replace(/vInfuseVideoSingle/g, ``)
                            }

                            let video;
                            if ( prj_details.length ) {
                                prj_details.resources.forEach( v => {
                                    if (v.file_id === extra_details.stage_video){
                                        video = v;
                                    }
                                });
                            }

                            if ( video ){
                                const visibility_record = Array.isArray(prj_details.resource_visibility)
                                    ? prj_details.resource_visibility.find(file => file.file_id == video.file_id)
                                    : null
                                const display_name = visibility_record && visibility_record.is_visible ? `${video.client_label} <i class="v-icon notranslate ml-2 mdi mdi-checkbox-marked-circle theme--light secondary--text" style="font-size: 19px;"></i>` : `${video.client_label}`;
                                const video_content = `<a data-function="playResourceVideo" data-fileid="${video.file_id}" data-url="${video.url}" data-title="${video.client_label}" data-type="${video.type}">${display_name}</a>`;
                                infused_content = content.stage_desc.replace(/vInfuseVideoSingle/g, `<p>${video_content}</p>`);
                            } else {
                                infused_content = content.stage_desc.replace(/vInfuseVideoSingle/g, ``);
                            }

                            return infused_content
                        break;

                        case 'vInfuseRevisedContract':
                            let contract_verbiage = 'contract'
                            if ( prj_details.length && prj_details.revs.length ) {
                                contract_verbiage = 'revised contract'
                            }
                            // infused_content = content.replace(/vInfuseRevisedContract/g, contract_verbiage)
                            infused_content = content.replace(/vInfuseRevisedContract/g, '[contract / revised contract]')

                            return infused_content
                        break;

                        case 'vInfuseScheduleCall':
                            let call_button_verbiage = display ? `<br/><br/>Please use the link below to schedule a consultation call.` : ''
                            infused_content = content.replace(/vInfuseScheduleCall/g, call_button_verbiage)

                            return infused_content
                        break;

                        case 'vInfuseScheduleDebriefCall':
                            let debrief_call_button_verbiage = display ? `<br/><br/>Please use the link below to schedule a debrief call with the valuation team.` : ''
                            infused_content = content.replace(/vInfuseScheduleDebriefCall/g, debrief_call_button_verbiage)

                            return infused_content
                        break;

                        case 'vInfuseUploadRevisions':
                            let upload_revision_button_verbiage = display ? `<br/><br/>Revisions? Please upload document(s) using the button below so we can incorporate any changes or clarifications.<br/><br/>No revisions, please click the checkbox below.`: ''
                            infused_content = content.replace(/vInfuseUploadRevisions/g, upload_revision_button_verbiage)

                            return infused_content
                        break;
                    }
                } catch ( err ) {

                }
            },
        },

        mounted: async function () {
            await this.adminOnly()
            this.module_roadmap_data = await this.getRoadmapSteps()
            this.readyToLoadRoadmap = true
        }
    }
</script>

<style scoped>
    .table_body td {
        padding-top: .5rem !important; 
        padding-bottom: .5rem !important;
        vertical-align: top !important;
    }
    .clean_link {
        text-decoration: none;
    }
    .bg_pewter {
        background-color: #E9EAEC;
    }
    .menu_bg_primary {
        background-color: #eef7f8 !important;
    }
    .icon-size {
        width: 3rem;
    }
    .icon-size-small {
        width: 2.25rem;
    }
    .icon-size-header {
        width: 2.5rem;
    }
    .icon-center {
        margin: 0 auto;
    }
</style>


// WEBPACK FOOTER //
// src/components/ModuleRoadmap.vue